import {
  actualizarOpcionesRespuesta,
  crearOpcionesRespuesta,
  eliminarOpcionesRespuesta,
  getOpcionesRespuestas,
} from 'api/opcionesRespuesta'
import { useMutation, useQuery, useQueryClient } from 'react-query'

import swal from 'sweetalert2'

const key = 'opcionesRespuestas'
export function useObtenerOpcionesRespuesta(buscar) {
  return useQuery(key, () => getOpcionesRespuestas(buscar))
}

export function useCrearOpcionesRespuesta() {
  const queryClient = useQueryClient()
  return useMutation(crearOpcionesRespuesta, {
    onSuccess: (response) => {
      const { data } = response
      queryClient.setQueryData(key, (prevState) => {
        const results = [data, ...prevState.results]
        return { ...prevState, results }
      })
    },
  })
}

export function useActualizarOpcionesRespuesta() {
  const queryClient = useQueryClient()
  return useMutation(actualizarOpcionesRespuesta, {
    onSuccess: (_, value) => {
      const { id, values: opcionesRespuestaActualizado } = value
      queryClient.setQueryData(key, (prevState) => {
        const results = prevState.results.map((opcionesRespuesta) => {
          let nuevoOpcionesRespuesta = opcionesRespuesta
          if (id === opcionesRespuesta.id) {
            nuevoOpcionesRespuesta = opcionesRespuestaActualizado
          }
          return nuevoOpcionesRespuesta
        })
        return { ...prevState, results }
      })
    },
  })
}

export function useEliminarOpcionesRespuesta() {
  const queryClient = useQueryClient()
  return useMutation(eliminarOpcionesRespuesta, {
    onSuccess: (_, value) => {
      queryClient.setQueryData(key, (prevState) => {
        const results = prevState.results.filter(
          (opcionesRespuesta) => opcionesRespuesta.id !== value.id,
        )
        return { ...prevState, results }
      })
    },
  })
}

export function useOpcionesRespuesta(onToggle) {
  const queryClient = useQueryClient()
  const { mutateAsync: eliminarOpcionesRespuesta } = useEliminarOpcionesRespuesta()
  const { mutateAsync: actualizarOpcionesRespuesta } = useActualizarOpcionesRespuesta()
  const { mutateAsync: crearOpcionesRespuesta } = useCrearOpcionesRespuesta()

  const handleCrearOpcionesRespuesta = async (values, acciones) => {
    try {
      const { data, onSuccessMessage } = await crearOpcionesRespuesta(values)
      const message = `La opcionesRespuesta ${data.nombre} fue creada satisfactoriamente!`
      onSuccessMessage({ text: message })
      acciones.resetForm()
      onToggle()
    } catch (error) {
      acciones.setErrors(error)
    }
  }

  const handleActualizarOpcionesRespuesta = async ({ id, values, acciones }) => {
    try {
      const { data, onSuccessMessage } = await actualizarOpcionesRespuesta({
        id,
        values,
      })
      if (data) {
        onSuccessMessage({
          text: 'La opcionesRespuesta fue actualizada satisfactoriamente!',
        })
        onToggle()
      }
    } catch (error) {
      acciones.setErrors(error)
    }
  }

  const handleEliminarOpcionesRespuesta = (id) => {
    swal
      .fire({
        title: 'Estás seguro?',
        text: 'Recuerda que no podrás revertir estos cambios!',
        type: 'warning',
        showCancelButton: true,
        confirmButtonColor: '#3085d6',
        cancelButtonColor: '#d33',
        confirmButtonText: 'Si, eliminalo!',
      })
      .then(async ({ value }) => {
        if (value) {
          const { data, onSuccessMessage } = await eliminarOpcionesRespuesta(id)
          const message = `La opcionesRespuesta ${data} fue eliminada satisfactoriamente!`
          onSuccessMessage({ text: message })
        }
      })
  }

  const handleBuscarOpcionesRespuesta = async (value) => {
    queryClient.prefetchQuery(key, () => getOpcionesRespuestas(value))
  }

  return {
    obtenerOpcionesRespuestas: useObtenerOpcionesRespuesta,
    handleEliminarOpcionesRespuesta,
    handleActualizarOpcionesRespuesta,
    handleCrearOpcionesRespuesta,
    handleBuscarOpcionesRespuesta,
  }
}
